import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="text-2xl" style={{ fontFamily: 'var(--font-heading)' }}>
                  <span className="text-primary-500">吃</span><span className="text-foreground-900">瓜</span><span className="text-accent-500">视</span><span className="text-foreground-900">频</span>
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                最新最热娱乐八卦、明星吃瓜、社会热点视频内容，每日实时更新，一站式吃瓜平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门频道</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/star-gossip" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">明星吃瓜</Link>
                <Link to="/category/entertainment" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">娱乐八卦</Link>
                <Link to="/category/social-hot" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">社会热点</Link>
                <Link to="/category/variety-show" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">综艺爆料</Link>
                <Link to="/category/influencer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">网红动态</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">品牌介绍</Link>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">联系我们</Link>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">用户协议</a>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">隐私政策</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">关注我们</h4>
              <div className="flex items-center gap-3">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 吃瓜视频 readyue.cn 版权所有
            </p>
            <p className="text-xs text-foreground-500">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-primary-600 transition-colors">京ICP备2024000001号-1</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}